// src/features/customers/components/CustomerServicesCard.tsx
import { GlassCard } from '../../../app/components/ui/GlassCard';
import { EmptyState } from '../../../app/components/foundation';

export type ServiceStatus = 'active' | 'expiring' | 'expired';

export interface CustomerService {
  id: string;
  name: string;
  status: ServiceStatus;
  expiryInfo: string;
}

/**
 * No customer-scoped services endpoint exists on the backend today —
 * only the global `GET /api/services` / `GET /api/services/{id}` are
 * available. Filtering the global services list by customer on the
 * frontend would misrepresent data the backend never actually scoped,
 * so this renders an explicit EmptyState instead, matching the same
 * pattern already used by `CustomerServicesSection` in the Customer
 * Workspace.
 *
 * `ServiceStatus`/`CustomerService` stay exported since `CustomerServiceRow`
 * still depends on their shape for when a scoped endpoint lands.
 */
export function CustomerServicesCard() {
  return (
    <GlassCard noPadding>
      <h2 className="px-5 pt-4 text-sm font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
        سرویس‌ها
      </h2>

      <div className="mt-2 pb-2">
        <EmptyState message="فهرست سرویس‌های این مشتری پس از افزوده شدن Endpoint سرویس‌های مشتری‌محور در دسترس خواهد بود." />
      </div>
    </GlassCard>
  );
}
